import { AxiosError } from 'axios';
import { ACCESS_DENIED_ERROR_CODE, NOT_FOUND_ERROR_CODE } from '../constants/error-status-code';

export const isAccessDenied = (error?: AxiosError) => {
  if (error == null || error?.response == null) {
    return false;
  } else {
    return error.response.status === ACCESS_DENIED_ERROR_CODE;
  }
};

export const isNotFound = (error?: AxiosError) => {
    if (error == null || error?.response == null) {
      return false;
    } else {
      return error.response.status === NOT_FOUND_ERROR_CODE;
    }
  };
  